/** @format */

import React from "react";
import AccountInfoPageContainer from "./AccountInfoPage.container";
import { useParams } from "react-router-dom";
import "./AccountInfoPage.css";

interface RouteParams {
	id: string;
}

const AccountInfoPage: React.FC = () => {
	const params: any = useParams();
	const { id } = params;

	const safeParams: RouteParams = {
		id: id || "default_id",
	};

	return <AccountInfoPageContainer params={safeParams} />;
};

export default AccountInfoPage;
